import { computed } from "vue";
import { defineStore } from "pinia";
import { useAppStore } from "#imports";

export const usePageStore = defineStore('pageStore', () => {
    const { txt } = storeToRefs(useAppStore());

    const pages = computed(() => [
        {
            title: txt.value.conductorWeightChart.title,
            id: 1,
            icon: 'mdi-menu-right',
            to: '/conductor-weight-chart',
            isShow: true
        },
        {
           title: txt.value.lengthOfConductorOnReel.title,
           id: 2,
           icon: 'mdi-menu-right',
           to: '/length-of-conductor-on-reel',
           isShow: true
        },
        {
           title: txt.value.slingTensionKnownAngle.title,
           id: 3,
           icon: 'mdi-menu-right',
           to: '/sling-tension-known-angle',
           isShow: true
        },
        {
           title: txt.value.slingTensionUnknownAngle.title,
           id: 4,
           icon: 'mdi-menu-right',
           to: '/sling-tension-unknown-angle',
           isShow: true
        },
        {
           title: txt.value.blockLoading.title,
           id: 5,
           icon: 'mdi-menu-right',
           to: '/block-loading',
           isShow: true
        },
        {
            title: txt.value.blockAndTackle.title,
            id: 6,
            icon: 'mdi-menu-right',
            to: '/block-and-tackle',
            isShow: true
        },
        {
           title: txt.value.guyLength.title,
           id: 7,
           icon: 'mdi-menu-right',
           to: '/guy-length',
           isShow: true
        },
        {
           title: txt.value.guyTension.title,
           id: 8,
           icon: 'mdi-menu-right',
           to: '/guy-tension',
           isShow: true
        },
        {
           title: txt.value.conductorWeightAtSupportPoint.title,
           id: 9,
           icon: 'mdi-menu-right',
           to: '/conductor-weight-at-support-point',
           isShow: true
        },
        {
           title: txt.value.lineTension.title,
           id: 10,
           icon: 'mdi-menu-right',
           to: '/line-tension',
           isShow: true
        },
        {
            title: txt.value.sagTimingMethod.title,
            id: 11,
            icon: 'mdi-menu-right',
            to: '/sag-timing-method',
            isShow: true
        },
        {
           title: txt.value.stringingTension.title,
           id: 12,
           icon: 'mdi-menu-right',
           to: '/stringing-tension',
           isShow: true
        },
        {
           title: txt.value.bisectTension.title,
           id: 13,
           icon: 'mdi-menu-right',
           to: '/bisect-tension',
           isShow: true
        },
        {
           title: txt.value.downPullVerticalWeight.title,
           id: 14,
           icon: 'mdi-menu-right',
           to: '/down-pull',
           isShow: true
        },
        {
           title: txt.value.hotLineToolWorkingLoads.title,
           id: 15,
           icon: 'mdi-menu-right',
           to: '/hot-line-tool-working-loads-vertical-weight',
           isShow: true
        }
    ]);

    return {
        pages
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(usePageStore, import.meta.hot));
}